<template>
  <div class="table-area">
    <div class="table-a">
      <div class="table-name">
        <h3 class="ico_table_name">{{title}}</h3>
      </div>
      <table id="basic" class="table infotable">
        <tbody>
          <tr>
            <th>진행단계</th>
            <th>반품일자</th>
            <th>반품구분</th>
            <th>제조사</th>
            <th>제품군</th>
            <th>품번</th>
            <th>품명</th>
            <th>반품수량</th>
          </tr>
          <tr>
            <!--<td><input class="input" type="text" v-model="this.$moment(form.inDt).format('YYYY-MM-DD')" style="text-align:center;" disabled ></td>-->
            <td><input class="input" type="text" v-model="form.procYn" style="text-align:center;" disabled ></td>
            <td><input class="input" type="text" v-model="form.outDt" style="text-align:center;" disabled ></td>
            <td><input class="input" type="text" v-model="form.outType" style="text-align:center;" disabled></td>
            <td><input class="input" type="text" v-model="form.makerNm" style="text-align:center;" disabled></td>
            <td><input class="input" type="text" v-model="form.itemGroupNm" style="text-align:center;" disabled></td>
            <td><input class="input" type="text" v-model="form.itemCd" style="text-align:center;" disabled></td>
            <td><input class="input" type="text" v-model="form.itemNm" style="text-align:center;" disabled></td>
            <td><input class="input" type="number" v-model="form.goodQty" style="text-align:right;" id="goodQty"></td>
            <input class="input" type="hidden" v-model="form.groupUid">
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>
<script>

import mixin from '@/mixin/lucoms';

export default {
  name: "mateReturnListInfo",
  mixins: [mixin],
  props: ['mateReturnListDetail'],
  data() {
    return {
      title : "반품자재정보 수정",
      form: {
        companyId : '',
        outItemId : 0,
        productType : 'Item',
        outAsAgentId : 0,
        outDt: '',
        outType : '',
        itemId : '',
        goodQty : 0,
        recycleQty : 0,
        badQty: 0,
        inAsAgentId : '',
        description : '',
        updatorId: '',
        processTime : ''

      },
    };
  },
  methods: {
    setMateReturnListDetailInfo() {
      Object.assign(this.form, this.mateReturnListDetail);

      this.form.procYn = this.form.procYn === 'NN' ? "반품대기" : (this.form.procYn === 'YN' ? "반품의뢰" : (this.form.procYn === 'YY' ? "반품확정" : ""));
      //this.form.outType = this.form.outType === 'UseNoItem' ? "미사용자재" : (this.form.outType === 'BadItem' ? "불량자재" : (this.form.outType === 'UseItem' ? "사용자재" : ""))
      this.form.outDt = this.form.outDt.substring(0, 10);



    },
    getConfigValue() {
      this.$http.get(`/api/config/keyPath/info`, {params: {keyPath: 'System.MainAsAgentId'}})
          .then(response => {
            this.form.inAsAgentId = response.data[0].configValue;
          });
    },

    mounted() {
      this.form.companyId = this.$store.state.loginInfo.compCd;
      this.form.outAsAgentId = this.$store.state.loginInfo.asAgentId;
      this.form.updatorId = this.$store.state.loginInfo.id;

    },

    validation() {
      const mateReturnListInfo = JSON.parse(JSON.stringify(this.form));
      const stripFields = ['goodQty'];
      _.forEach(stripFields, (name) => mateReturnListInfo[name] = this.toPure(mateReturnListInfo[name]));

      if (!mateReturnListInfo.goodQty || mateReturnListInfo.goodQty == 0 ) {
        this.$swal({type: 'warning', text: '반품수량을 입력해 주세요.'});
        return false;
      }

      return true;
    },

  },
  watch: {
    mateReturnListDetail() {
      this.setMateReturnListDetailInfo();

      if(this.form.outType == 'UseNoItem' && this.form.procYn == '반품의뢰' && this.form.outDt !== null){
        document.getElementById("goodQty").disabled = false;
      }else{
        document.getElementById("goodQty").disabled = true;
      }

    }

  }
}
</script>

<style scoped>
</style>